// DayPasses reducer

import { initializeState } from '../../../utilities/storageUtils';
import dayPassActionTypes from './dayPasses.types';

const INITIAL_STATE = {
  numberOfGuests: 0,
  arrivalDate: null,
  departureDate: null,
  selectedTitle: '',
  selectedRate: 0,
  selectedRateCode: '',
  selectedItemCode: '',
  selectedDescription: '',
  availabilityKey: null,
  promoCode: '',
  qualifyingId: '',
  item: {
    rate: '',
    itemCode: '',
    rateCode: ''
  },
  availabilityData: [],
  seasonInfo: null,
  promoCodeData: null,
  isDaypassFetching: false,
  isSeasonPassLoading: false,
  parkingFee: 0,
  resortFee: 0,
  sustainabilityFee: 0,
  taxesAndFees: 0,
  passType: null,
  total: 0
};

const dayPassesReducer = (state, action) => {
  state = initializeState(state, INITIAL_STATE);

  switch (action.type) {
    case dayPassActionTypes.SET_DAYPASSES:
      return {
        ...state,
        availabilityKey: action.availabilityKey,
        arrivalDate: action.arrivalDate,
        numberOfGuests: action.numberOfGuests,
        selectedTitle: action.selectedTitle,
        selectedRate: action.selectedRate,
        selectedItemCode: action.selectedItemCode,
        selectedRateCode: action.selectedRateCode,
        promoCode: action.promoCode,
        qualifyingId: action.qualifyingId,
        selectedDescription: action.selectedDescription,
        parkingFee: action.parkingFee,
        resortFee: action.resortFee,
        sustainabilityFee: action.sustainabilityFee,
        taxesAndFees: action.totalTaxesAndFees,
        item: [action.item]
      };
    case dayPassActionTypes.SET_DAYPASSES_AVAILABLE_DATES:
      // We get the month of the request if the request has days
      const date =
        action.availabilityData?.dayPasses?.length > 0 ? new Date(action.availabilityData.dayPasses[0].date) : null;
      const monthFromAPI = date ? date.getMonth() + 1 : null;
      const isLastInfo = monthFromAPI === action.date?.month && date.getFullYear() === action.date.year;

      const obj = {
        ...state,
        promoCodeData: action.availabilityData?.promotion ? action.availabilityData.promotion : '',
        ...(isLastInfo && {
          availabilityData: action.availabilityData?.dayPasses ? action.availabilityData.dayPasses : []
        }),
        seasonInfo: action.seasonInfo || null
      };
      return obj;
    case dayPassActionTypes.UPDATE_DAYPASSES_FETCHING:
      return {
        ...state,
        isDaypassFetching: action.fetchData.isDaypassFetching,
        ...(action.fetchData.isDaypassFetching && { availabilityData: [] })
      };
    case dayPassActionTypes.SET_SEASONPASS:
      return {
        ...state,
        arrivalDate: action.arrivalDate,
        numberOfGuests: action.numberOfGuests,
        departureDate: action.departureDate,
        selectedTitle: action.selectedTitle,
        selectedDescription: action.selectedDescription,
        selectedRate: action.selectedRate,
        selectedItemCode: action.selectedItemCode,
        passType: action.passType,
        availabilityKey: action.availabilityKey
      };
    case dayPassActionTypes.SET_SEASONPASS_CHARGES:
      return {
        ...state,
        taxesAndFees: action.charges?.totalTaxesAndFees,
        resortFee: action?.charges?.resortFee,
        total: action?.charges?.total
      };
    case dayPassActionTypes.SET_SEASON_PASS_LOADING:
      return {
        ...state,
        isSeasonPassLoading: action.isLoading
      };
    case dayPassActionTypes.CLEAR_DAYPASSES:
      return INITIAL_STATE;
    default:
  }

  return state;
};

export default dayPassesReducer;
